import { FC, PropsWithChildren } from 'react';
import { Interpolation, Theme } from '@emotion/react';
import { cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { AnimatedBadge } from '../animated-badge';
import { BadgeBannerStyles } from './badge-banner.styles';

type BadgeBannerProps = FC<
  PropsWithChildren<{
    backgroundColor?: string;
    borderColor?: string;
    /** @deprecated use className instead */
    styles?: Interpolation<Theme>;
    className?: string;
  }>
>;

interface BadgeBannerNamespace extends BadgeBannerProps {
  AnimatedBadge: typeof AnimatedBadge;
  Title: typeof Title;
}

export const BadgeBanner: BadgeBannerNamespace = ({
  backgroundColor = theme.colors.secondary.seaweed5,
  borderColor = theme.colors.secondary.seaweed50,
  children,
  className,
  styles,
}) => {
  const cssVars = {
    '--badge-banner-bg': backgroundColor,
    '--badge-banner-border': borderColor,
  } as React.CSSProperties;

  return (
    <div css={styles} className={cx(BadgeBannerStyles.banner, className)} style={cssVars}>
      {children}
    </div>
  );
};

export const Title: FC<PropsWithChildren> = ({ children }) => {
  return <Text size='medium'>{children}</Text>;
};

BadgeBanner.Title = Title;
BadgeBanner.AnimatedBadge = AnimatedBadge;
